/* ============================================================
   The Money–Body Code — cookie-consent.js
   Wires the on-brand cookie banner (snippets/cookie-consent.liquid)
   to Shopify's Customer Privacy API. That API isn't present on
   window.Shopify by default — it has to be requested via
   loadFeatures before window.Shopify.customerPrivacy exists.

   shouldShowBanner() only reflects region eligibility, not whether
   the visitor already answered — it stays true forever for anyone
   in a consent-required region. currentVisitorConsent() has to be
   checked too, or the banner re-shows on every reload post-accept.
   ============================================================ */
(function () {
  var banner = document.getElementById('cookie-consent');
  if (!banner) return;

  var acceptBtn = banner.querySelector('[data-cookie-accept]');
  var declineBtn = banner.querySelector('[data-cookie-decline]');

  function show() {
    banner.hidden = false;
    requestAnimationFrame(function () {
      banner.classList.add('is-visible');
    });
  }

  function hide() {
    banner.classList.remove('is-visible');
    window.setTimeout(function () {
      banner.hidden = true;
    }, 500);
  }

  function setConsent(consentGiven) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      hide();
      return;
    }
    privacy.setTrackingConsent(
      {
        analytics: consentGiven,
        marketing: consentGiven,
        preferences: consentGiven,
        sale_of_data: consentGiven
      },
      function () {
        hide();
      }
    );
  }

  if (acceptBtn) acceptBtn.addEventListener('click', function () { setConsent(true); });
  if (declineBtn) declineBtn.addEventListener('click', function () { setConsent(false); });

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  function alreadyAnswered(privacy) {
    if (typeof privacy.currentVisitorConsent !== 'function') return false;
    var consent = privacy.currentVisitorConsent();
    return !!(consent && (consent.marketing || consent.analytics || consent.preferences || consent.sale_of_data));
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error) return;
      var privacy = window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.shouldShowBanner !== 'function') return;
      if (privacy.shouldShowBanner() && !alreadyAnswered(privacy)) {
        show();
      }
    }
  );
})();
